import React from "react";
import { FieldArray, FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { CancelOrderFormFormValue } from "src/models/OfflineOrder.model";

import { handleValidDecimalNumber, handleValidNumber2 } from "src/utils/formUtils/ValidNumber";
import usePaymentModes from "src/hooks/usePaymentModes";

type Props = {
  formikProps: FormikProps<CancelOrderFormFormValue>;
  onClose: () => void;
};

const CancelOrderForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const { paymentMode: paymentModes } = usePaymentModes();

  const getPaymentModes = (type: "PHYSICAL" | "VIRTUAL") => {
    return (
      paymentModes
        ?.filter((pm: any) => pm?.type === type)
        .map((pm: any) => ({
          label: pm?.name,
          value: pm?.value,
          type: pm?.type,
        })) || []
    );
  };

  const virtualPaymentModes = getPaymentModes("VIRTUAL");

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
         Delete order 
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 md:grid-cols-4  gap-2">
          <div>
            <ATMTextField
              name="reason"
              value={values.reason}
              required
              placeholder="Enter cancel reason"
              onChange={(e) => {
                setFieldValue("reason", e.target.value);
              }}
              label="Cancel Reason"
            />
          </div>
          <div>
            <ATMTextField
              name="givenAmount"
              value={values.givenAmount}
              placeholder="Enter given amount"
              onChange={(e) => {
                handleValidDecimalNumber(e) &&
                  setFieldValue("givenAmount", e.target.value);
              }}
              label="Given Amount"
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="border px-4 py-2">Note Value</th>
                <th className="border px-4 py-2">Quantity</th>
                <th className="border px-4 py-2">Total Amount</th>
              </tr>
            </thead>
            <tbody>
              <FieldArray name="paymentMode">
                {() =>
                  // values.paymentMode.map((note, index) => {
                  //   const quantityValue = note.quantity || "";
                  values.paymentMode.filter((item)=>item.type==="PHYSICAL").map((note, index) => {
                    const availableQty = Number(note.availableQuantity || 0);
                    const isDisabled = availableQty === 0;
                    const quantityValue = note.quantity || "";
                    return (
                      <tr key={index}>
                        <td className="border px-4 py-2">{note.name} X</td>
                        <td className="border px-4 py-2">
                          <ATMTextField
                            name={`paymentMode[${index}].quantity`}
                            value={values.paymentMode[index].quantity}
                            disabled={isDisabled}
                            onChange={(e) =>
                              handleValidNumber2(e) &&
                              setFieldValue(
                                `paymentMode[${index}].quantity`,
                                e.target.value
                              )
                            }
                            placeholder="Enter quantity"
                            onBlur={handleBlur}
                          />
                          <span className="text-[12px] mt-1 flex justify-end">
                            {" "}
                            {isDisabled ? (
                              <span className="text-red-400">
                                Not available
                              </span>
                            ) : (
                              <span>
                                Total available quantity {availableQty}
                              </span>
                            )}
                          </span>
                        </td>
                        <td className="border px-4 py-2">
                          {note.value * Number(quantityValue || 0)}
                        </td>
                      </tr>
                    );
                  })
                }
              </FieldArray>
            </tbody>
          </table>
        </div>
        <div className="border rounded-md p-1">
          <table className="w-full border text-left">
            <thead>
              <tr className="bg-gray-100 text-sm">
                <th className="p-2">Payment In</th>
                <th className="p-2">Amount</th>
              </tr>
            </thead>
            <tbody>
              {virtualPaymentModes?.map((mode, i) => {
                const item = values.paymentMode.find(
                  (item) => item.name === mode.label
                ) || { value: 0 };

                return (
                  <tr key={i} className="border-t">
                    <td className="p-2">{mode.label}</td>
                    <td className="p-2">
                      <ATMTextField
                        name={`paymentMode_${mode.value}`}
                        value={item.value.toString()}
                        onChange={(e) => {
                          const amount = e.target.value;
                          if (
                            handleValidDecimalNumber(e) &&({
                              target: { value: amount },
                            } as React.ChangeEvent<HTMLInputElement>)
                          ) {
                            const newpaymentMode = values.paymentMode.filter(
                              (item) => item.name !== mode.label
                            );

                            if (amount) {
                              newpaymentMode.push({
                                name: mode.label,
                                value: Number(amount),
                                quantity: 1,
                                type: mode.type,
                              });
                            }

                            setFieldValue("paymentMode", newpaymentMode);
                          }
                        }}
                        onBlur={handleBlur}
                        label=""
                        placeholder="Amount"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default CancelOrderForm;
